import { render } from "./EditSubResource.vue?vue&type=template&id=a45d88a8"
import script from "./EditSubResource.vue?vue&type=script&lang=js"
export * from "./EditSubResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__